<template>
  <div v-if="showFullScreenBtn" class="full-screen-btn-con header-icon-button">
    <Tooltip class="fullscreen-tooltip" :content="value ? langMap.exitFullscreen[lang] : langMap.fullscreen[lang]" placement="bottom">
      <Icon class="fullscreen-icon" @click.native="handleChange" :type="value ? 'md-contract' : 'md-expand'" :size="22"></Icon>
    </Tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import langMap from '@/utils/language'

export default {
  name: 'Fullscreen',
  data() {
    return {
      langMap:langMap
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    }),
    showFullScreenBtn () {
      return window.navigator.userAgent.indexOf('MSIE') < 0
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleFullscreen (el) {
      let main = el || document.body;
      if (this.value) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
      }
    },
    handleChange () {
      this.handleFullscreen()
    }
  },
  mounted () {
    let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
    isFullscreen = !!isFullscreen
    document.addEventListener('fullscreenchange', () => {
      this.$emit('input', !this.value)
      this.$emit('on-change', !this.value)
    })
    document.addEventListener('mozfullscreenchange', () => {
      this.$emit('input', !this.value)
      this.$emit('on-change', !this.value)
    })
    document.addEventListener('webkitfullscreenchange', () => {
      this.$emit('input', !this.value)
      this.$emit('on-change', !this.value)
    })
    document.addEventListener('msfullscreenchange', () => {
      this.$emit('input', !this.value)
      this.$emit('on-change', !this.value)
    })
    this.$emit('input', isFullscreen)
  }
}
</script>

<style lang="less">
.header-icon-button {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  margin: 0;
  transform: translateY(15px);
  box-sizing: border-box;
  line-height: 0;
  vertical-align: middle;
  border: 1px solid rgba(45, 140, 240, 0.18);
  border-radius: 8px;
  background: linear-gradient(145deg, rgba(45, 140, 240, 0.1), rgba(45, 140, 240, 0.03));
  color: #617c9b;
  transition: border-color .2s ease, background .2s ease, box-shadow .2s ease, color .2s ease;
}
.header-icon-button:hover {
  border-color: rgba(45, 140, 240, 0.58);
  background: rgba(45, 140, 240, 0.13);
  box-shadow: 0 0 0 3px rgba(45, 140, 240, 0.06);
  color: #2d8cf0;
}

.full-screen-btn-con .fullscreen-tooltip,
.full-screen-btn-con .fullscreen-tooltip .ivu-tooltip-rel {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.full-screen-btn-con .fullscreen-icon {
  line-height: 1;
  cursor: pointer;
}
</style>
